import React, { useEffect } from 'react';
import Post from './Pages/Post/Post';
import { CssBaseline, Container, Grid, Typography } from '@mui/material';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import MainLayout from './Layouts/MainLayout';
import AppRoutes from './routes/AppRoutes';
import NetworkStatusNotifier from './services/NetworkStatusNotifier';
import NotificationStack from './Components/NotificationStack';
import { LoadScript } from '@react-google-maps/api';
import axios from 'axios';
import useFirebaseMessaging from './hooks/useFirebaseMessaging';
import { requestFirebaseNotificationPermission } from './services/firebaseMessaging';
import { navigationService } from './services/navigationService';
import useGlobalChatNotifications from './hooks/useGlobalChatNotifications';
import GridWrapper from './Components/GridWrapper';

// Inner component to access useNavigate hook
const AppContent: React.FC = () => {
  const navigate = useNavigate();
  
  // Initialize navigation service
  useEffect(() => {
    navigationService.setNavigate(navigate);
  }, [navigate]);

  // Initialise Firebase Cloud Messaging when user is logged-in
  useFirebaseMessaging();

  // Global chat notifications - works across all screens
  useGlobalChatNotifications();


  // get the ip address of the user (v4 address)
  
  useEffect(() => {


    const registerFcmToken = async () => {
      if (!('serviceWorker' in navigator)) return;
      try {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        const token = await requestFirebaseNotificationPermission(registration);
        if (token) {
          console.log("token every time",token);
        }
      } catch (err) {
        console.error('[FCM] Failed to generate FCM token', err);
      }
    };
    registerFcmToken();
  }, []);
  



  return (
    <MainLayout>
      <NetworkStatusNotifier />
      <NotificationStack />
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY || ""}
        libraries={["places", "geometry"]}
      >
        <AppRoutes />
      </LoadScript>
    </MainLayout>
  );
};

const App: React.FC = () => {
  return (
   <GridWrapper>
        <Router>
          <AppContent />
        </Router>
   </GridWrapper>
   
  );
}

export default App;
